import React from 'react';
import Default from './apps/Default';
import Cancel from './apps/Cancel';
import Rescheduling from './apps/Rescheduling';

export default function getApp(appReference, eligibilityConfig) {
  const apps = {
    'cancel': Cancel,
    'rescheduling': Rescheduling,
    'default': Default
  };

  const AppComponent = appReference in apps ? apps[appReference]: apps['default'];
  return <AppComponent eligibilityConfig={eligibilityConfig} />
};
